import { updateSlideNumber } from "../mobile/02-mobile_devices";

function SSTouchInteraction(config){
  this.config = config;
  this._init();
}

SSTouchInteraction.prototype._init = function(){
  this.touch = {active: false};
  this._bindEvents();
};

SSTouchInteraction.prototype.scrollVariables = function(){
  this.slideHeight = $('.verticalStack').height();
  this.scrollBottomOffset = this.slideHeight * 2 ;
};

SSTouchInteraction.prototype.loadNextSlides = function(e){
  var eagerLoadLimit = 2;
  var that = e.data.touch;
  var scrollTop = $(window).scrollTop();
  var containerHeight = $('.slideShow').height();

  if (containerHeight - scrollTop < that.scrollBottomOffset){
    for(var i=0; i < eagerLoadLimit ; i++){
      $.slideshareEventManager.trigger('next', {source : 'scroll_next'});
    }
  }
};

SSTouchInteraction.prototype.loadNextSlide = function(e){
  var touchedSlide = $(e.target);
  if(!touchedSlide.hasClass('.verticalStack')){
    touchedSlide = touchedSlide.closest('.verticalStack');
  }
  var touchCount = parseInt(touchedSlide.attr('touchCount'), 10) ;
  var touchedSlideNo = parseInt(touchedSlide.attr('slideNumber'), 10) ;
  if(isNaN(touchedSlideNo)){
    touchedSlideNo = parseInt($('div[touchcount]').last().attr('slidenumber'), 10);
  }
  if(isNaN(touchCount)){
    touchedSlide.attr('touchCount', 1);
    $.slideshareEventManager.trigger('next', {source : 'scroll_next', 'touchedSlideNo' :  touchedSlideNo});
    window._gaq.push(['_trackEvent', 'jsplayer', 'slideTouched', this.config.player_type]);
  }else if(touchCount < 3 ){
    //Each times user touch a slide we will load a slide till 3rd touch.
    touchedSlide.attr('touchCount', touchCount+1);
    $.slideshareEventManager.trigger('next', {source : 'scroll_next', 'touchedSlideNo' :  touchedSlideNo});
  }
  if((touchedSlideNo === 1 && touchCount > 1) || window.orientation === 90 || window.orientation === -90){
      updateSlideNumber(touchedSlideNo);
  }else{
      updateSlideNumber(touchedSlideNo + 1);
  }
};

SSTouchInteraction.prototype.getTouchEvent = function(){
  var eventName;
  if ( 'ontouchstart' in window ){
    eventName = 'touchstart';
  }else if ( window.navigator.msPointerEnabled ){
    eventName = 'MSPointerDown';
  }else{
    eventName = 'click';
  }
  return eventName;

};


SSTouchInteraction.prototype.slideNextOnScroll = function(){
  var that = this;

  if(!this.config.scroll_test){
    $('#slideshow').on(this.getTouchEvent(), function(e) {
      that.loadNextSlide(e);
    });
  }

  $('#more-slide').on('click', function(e) {
    window._gaq.push(['_trackEvent', 'jsplayer', 'LoadMoreSlide', that.config.player_type]);
    that.loadNextSlide(e);
  });
};
//For Non touch devices SSTouchInteraction does not get activated .
SSTouchInteraction.prototype.activate = function(){
  var hideControls = $(".hideControls");
  var slideshow_container = $('.slideShow');
  var eventManager = $.slideshareEventManager;
  var respondToEvent = this.getTouchEvent();
  var that = this;

  // Set container width for mobile embeds
  var screenWidth = window.innerWidth > 0 ? window.innerWidth : screen.width;
  var containerWidth = this.config.container.width();
  if(this.config.hostedIn === "embed" && screenWidth < containerWidth) {
    $('body').width(screenWidth);
  }

  hideControls.show();

  $("#slide_next_mobile").on(respondToEvent, function(e) {
    e.preventDefault();
    eventManager.trigger('next', {source : 'tap_next'});

    window._gaq.push(['_trackEvent', 'jsplayer', 'mobile_next', that.config.real_player_type]);
  });

  $("#slide_previous_mobile").on(respondToEvent, function(e) {
    e.preventDefault();
    eventManager.trigger('previous', {source : 'tap_previous'});
    window._gaq.push(['_trackEvent', 'jsplayer', 'mobile_prev', that.config.real_player_type]);
  });

  if(typeof new_mobile_player !== 'undefined'){
    $("#slide-end").on(respondToEvent, function(e){
      $(window).scrollTop(0);
    });
    this.slideNextOnScroll();

    $('#play-icon').on(this.getTouchEvent(), function(e) {
      e.stopPropagation();
      if(typeof that.containerHeight !== 'undefined'){
        slideshow_container.height(that.containerHeight);
      }else{
        slideshow_container.height($('.verticalStack').height() * 2 );
      }
      $('#play-icon, .presentationSharing, #more-related-content').hide();
      $('#view-done, #view-save, #slidecount, #more-slide').show();
      $('.header').removeClass('fixed-header');
      if(that.config.scroll_test){
        that.scrollVariables();
        $(window).bind('scroll', {touch : that}, that.loadNextSlides);
      }
      eventManager.trigger('mobileScrollPlayingMode', 'play');
      window._gaq.push(['_trackEvent', 'jsplayer', 'Mobile_PlayButton', that.config.player_type]);
    });

    $('#view-done').on(this.getTouchEvent(), function(e) {
      e.stopPropagation();
      e.preventDefault();
      that.containerHeight = slideshow_container.height();
      slideshow_container.height($('.verticalStack').height());
      $('#view-done, #view-save, #slidecount, #more-slide, #slide-end').hide();
      $('.header').addClass('fixed-header');
      eventManager.trigger('mobileScrollPlayingMode', 'pause');
      $.mobile.silentScroll(0);
      $('.presentationSharing, #more-related-content' ).show();
      $('#play-icon').css('display', 'table');
      if(that.config.scroll_test){
        $(window).unbind('scroll', that.loadNextSlides);
      }
      window._gaq.push(['_trackEvent', 'jsplayer', 'Mobile_ViewDoneButton', that.config.player_type]);
    });

    var $view_save = $('#view-save');

    $view_save.on(this.getTouchEvent(), function(e) {
      e.stopPropagation();
      e.preventDefault();
      if (!$view_save.hasClass('mobile_view_saved')) { // If user has already saved, do nothing.
        $view_save.addClass('mobile_view_saved');
        var url = $view_save.data("save-url");
        window._gaq.push(['_trackEvent', 'jsplayer', 'Mobile_ViewSaveButton_Click', that.config.player_type]);
        $.ajax({
          url: url,
          success: function(response){
            if(response.success){
              window._gaq.push(['_trackEvent', 'jsplayer', 'Mobile_ViewSaveButton_Success', that.config.player_type]);
            } else {
              $view_save.removeClass('mobile_view_saved');
              window._gaq.push(['_trackEvent', 'jsplayer', 'Mobile_ViewSaveButton_Failure', that.config.player_type]);
            }
          },
          error: function(data){
            $view_save.removeClass('mobile_view_saved');
            window._gaq.push(['_trackEvent', 'jsplayer', 'Mobile_ViewSaveButton_Error', that.config.player_type]);
          }
        });
      }
    });

    $(document).bind('touchmove', function(e) {
      if ($view_save.is(':visible')) {
        $view_save.addClass('scrolling-hide');
        $('#view-done, #view-save').hide();
      }
    });

    $(document).bind(this.getTouchEvent(), function(e) {
      if ($view_save.hasClass('scrolling-hide')) {
        $view_save.removeClass('scrolling-hide');
        $('#view-done, #view-save').show();
      }
    });

  } else {
    hideControls.on(respondToEvent, function(e) {
    var timeout_limit = 1000;
    var slideNumber = parseInt($('.current_slide_number').text(),10);
    var prevButtonMobile = $('.previous .ui-btn-inner');
    var nextButtonMobile = $('.next .ui-btn-inner');
    var slideCount = $('.landscape-full-screen-slidecount');

    slideCount.show();
    setTimeout(function() {
     slideCount.hide();
    }, timeout_limit);
    if(slideNumber !== 1){
      prevButtonMobile.show();
      setTimeout(function(){
        prevButtonMobile.hide();
      }, timeout_limit);
    }

    if(slideNumber !== parseInt($('#total_slides_number').text(),10)){
      nextButtonMobile.show();
      setTimeout(function(){
        nextButtonMobile.hide();
      }, timeout_limit);
    }else{
      setTimeout(function(){
        $('.lastScreen').css('z-index',99999);
      },2000);
    }
    if(slideNumber === 4){
      $('.navIcons').removeClass('highlight');
    }
  });
  }
};

SSTouchInteraction.prototype.deactivate = function(){};

SSTouchInteraction.prototype.destroy = function(){};

SSTouchInteraction.prototype._bindEvents = function(){
};

export default SSTouchInteraction;
